"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT_BOT_CONTEXT = void 0;

var _react = require("react");

/* istanbul ignore file */
// NOTE: Context is an object to support adding additional properties in the future w/o affecting
// the existing API
var DEFAULT_BOT_CONTEXT = {
  isSearchEngineCrawler: false
};
/**
 * To use the bot-specific server-side rendering you must populate the BotContext object with the
 * isSearchEngineCrawler state. In most contexts you can use the user agent http attribute to detect
 * crawlers.
 *
 * - If you do not supply this context, then bots will not see any content that renders client side.
 * - If you supply this context, and the user is a bot, then everything that can render server side,
 *   will.
 *
 * To do this, you can wrap your components with this:
 *
 *     <BotContext.Provider value={{ isSearchEngineCrawler }} />
 */

exports.DEFAULT_BOT_CONTEXT = DEFAULT_BOT_CONTEXT;
var BotContext = /*#__PURE__*/(0, _react.createContext)(DEFAULT_BOT_CONTEXT);
var _default = BotContext;
exports.default = _default;